import Svg, { Path } from "react-native-svg";

import { useAppTheme } from "@/hooks/useAppTheme";

export const HouseholdSidebarOutlineIcon = () => {
  return (
    <Svg width="22" height="22" viewBox="0 0 22 22" fill="none">
      <Path
        d="M9.42859 19.643V13.3572C9.42859 12.9233 9.78037 12.5715 10.2143 12.5715H19.6429C20.0767 12.5715 20.4286 12.9233 20.4286 13.3572V19.643C20.4286 20.0768 20.0767 20.4287 19.6429 20.4287H10.2143C9.78037 20.4287 9.42859 20.0768 9.42859 19.643Z"
        stroke="white"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M1.57144 19.643V13.3572C1.57144 12.9233 1.92322 12.5715 2.35716 12.5715H5.51573C5.94966 12.5715 6.30144 12.9233 6.30144 13.3572V19.643C6.30144 20.0768 5.94966 20.4287 5.51573 20.4287H2.35716C1.92322 20.4287 1.57144 20.0768 1.57144 19.643Z"
        stroke="white"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M1.57144 8.64296V2.35725C1.57144 1.92331 1.92322 1.57153 2.35716 1.57153H11.7857C12.2197 1.57153 12.5714 1.92331 12.5714 2.35725V8.64296C12.5714 9.0769 12.2197 9.42868 11.7857 9.42868H2.35716C1.92322 9.42868 1.57144 9.0769 1.57144 8.64296Z"
        stroke="white"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M15.6986 8.64296V2.35725C15.6986 1.92331 16.0503 1.57153 16.4843 1.57153H19.6429C20.0768 1.57153 20.4286 1.92331 20.4286 2.35725V8.64296C20.4286 9.0769 20.0768 9.42868 19.6429 9.42868H16.4843C16.0503 9.42868 15.6986 9.0769 15.6986 8.64296Z"
        stroke="white"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export const HouseholdSidebarFilledIcon = () => {
  const { resolvedColors } = useAppTheme();

  return (
    <Svg width="22" height="22" viewBox="0 0 22 22" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.2143 19.6429C21.2143 20.5108 20.5107 21.2143 19.6428 21.2143H10.2143C9.34639 21.2143 8.64285 20.5108 8.64285 19.6429V13.3571C8.64285 12.4893 9.34641 11.7857 10.2143 11.7857H19.6428C20.5107 11.7857 21.2143 12.4893 21.2143 13.3571V19.6429ZM19.6428 10.2143C20.5107 10.2143 21.2143 9.51073 21.2143 8.64286V2.35714C21.2143 1.48927 20.5107 0.785715 19.6428 0.785715H16.4843C15.6164 0.785715 14.9128 1.48927 14.9128 2.35714V8.64286C14.9128 9.51073 15.6164 10.2143 16.4843 10.2143H19.6428ZM11.7857 10.2143C12.6536 10.2143 13.3571 9.51073 13.3571 8.64286V2.35714C13.3571 1.48927 12.6536 0.785715 11.7857 0.785715L2.35713 0.785713C1.48926 0.785713 0.785707 1.48927 0.785707 2.35714L0.785706 8.64286C0.785706 9.51073 1.48926 10.2143 2.35713 10.2143H11.7857ZM5.51572 21.2143C6.38359 21.2143 7.08715 20.5108 7.08715 19.6429V13.3571C7.08715 12.4893 6.38359 11.7857 5.51572 11.7857H2.35715C1.48927 11.7857 0.785721 12.4893 0.785721 13.3571V19.6429C0.785721 20.5108 1.48927 21.2143 2.35715 21.2143H5.51572Z"
        fill={resolvedColors.sidebar}
      />
    </Svg>
  );
};
